export default __webpack_public_path__ + "static/media/feather _ globe.0b35f89d.svg";